/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/campaign/:campaign_id/message/:message_variation_id/latest_test_results" endpoint
 * @owner @Appboy/whats-app
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCampaignCampaignIdMessageMessageVariationIdLatestTestResults } from "./constants";
import type { CampaignMessageLatestTestResultsResponse } from "./types";

export const getEngagementAppGroupIdCampaignCampaignIdMessageMessageVariationIdLatestTestResults =
  reactQueryFetcherAdapter(
    engagementAppGroupIdCampaignCampaignIdMessageMessageVariationIdLatestTestResults,
    (
      signal: AbortSignal,
      appGroupId: string,
      campaignId: string,
      messageVariationId: string
    ): Promise<CampaignMessageLatestTestResultsResponse> => {
      return fetch(
        `/engagement/${appGroupId}/campaign/${campaignId}/message/${messageVariationId}/latest_test_results`,
        "GET",
        {},
        { signal }
      );
    }
  );
